import { render } from "./chaxunc.vue?vue&type=template&id=3ee64aa8&scoped=true"
import script from "./chaxunc.vue?vue&type=script&lang=js"
export * from "./chaxunc.vue?vue&type=script&lang=js"

import "./chaxunc.vue?vue&type=style&index=0&id=3ee64aa8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3ee64aa8"

export default script